import { Column } from "@silevis/reactgrid";
import {
  DIGITS_WITH_UNDERSCORE,
  isDigitsOnly,
} from "../Components/Table/TableHelpers";

export const tabKeyMap: Record<string, string> = {
  Budget: "cr864_budgetrecords",
  FTE: "new_headcounts",
  "Sumár - Zjednotená kategória": "cr864_budgetrecords",
  "Sumár - Zložky mzdy": "cr864_budgetrecords",
  "Sumár - ASIS/Legislatíva/Projekt": "cr864_budgetrecords",
  "Summary FTE": "new_headcounts",
  "Original Budget": "cr864_budgetrecordcopies",
  "Original FTE": "new_originalftes",
  "History Budget": "new_historybudgets",
  "History FTE": "new_historyftes",
};

export const selectedTabSwitch = (selectedTab: string): string | undefined =>
  tabKeyMap[selectedTab];

export const renames = [
  { oldName: "identifier", newName: "Identifikátor" },
  { oldName: "identifikator", newName: "Identifikátor" },
  { oldName: "asisproject", newName: "ASIS/PROJEKT" },
  { oldName: "phpc", newName: "PH/PC" },
  { oldName: "codecompany", newName: "CODE COMPANY" },
  { oldName: "unifiedcategory", newName: "Zjednotená kategória" },
  { oldName: "category", newName: "Kategória" },
  { oldName: "kategoria", newName: "Kategória" },
  {
    oldName: "collectioncategoryinbp",
    newName: "Zberná kategória v BP",
  },
  {
    oldName: "zjednotenakategoria",
    newName: "Zjednotená kategória",
  },
  { oldName: "asisprojekt", newName: "ASIS/PROJEKT" },
  {
    oldName: "zbernakategoriavbp",
    newName: "Zberná kategória v BP",
  },
  {
    oldName: "costcenter_value",
    newName: "Nákladové stredisko",
  },
];

export const renameField = (name: string) => {
  let newName: string;
  if (name.startsWith("cr864__")) {
    newName = name.slice(7);
  } else if (name.startsWith("cr864_")) {
    newName = name.slice(6);
  } else if (name.startsWith("new_")) {
    newName = name.slice(4);
  } else if (name.startsWith("_new")) {
    newName = name.slice(5);
  } else {
    newName = " ";
  }

  renames.forEach((r) => {
    if (r.oldName == newName) {
      newName = r.newName;
    }
  });

  return newName;
};

export const sortColumns = (
  columns: Column[],
  priorityColumns: string[],
  isBudget?: boolean
): Column[] => {
  const isPriority = (col: Column) =>
    priorityColumns.includes(String(col.columnId));

  const getSortKey = (col: Column) =>
    isBudget ? renameField(String(col.columnId)) : String(col.columnId);

  return [
    ...priorityColumns
      .map((priority) =>
        columns.find((col) => String(col.columnId) === priority)
      )
      .filter((col): col is Column => !!col),
    ...columns
      .filter((c) => !isPriority(c))
      .sort((a, b) => {
        const aId = getSortKey(a);
        const bId = getSortKey(b);

        if (isBudget) {
          const aMatch = aId.match(DIGITS_WITH_UNDERSCORE);
          const bMatch = bId.match(DIGITS_WITH_UNDERSCORE);
          if (aMatch && bMatch) {
            const [, aPre, aSuf] = aMatch;
            const [, bPre, bSuf] = bMatch;
            if (aPre !== bPre) return aPre.localeCompare(bPre);
            if (aSuf && bSuf) return Number(aSuf) - Number(bSuf);
          }
        }

        if (isDigitsOnly(aId) && isDigitsOnly(bId)) {
          return Number(aId) - Number(bId);
        }
        return aId.localeCompare(bId);
      }),
  ];
};
